import mainView from "./mainView";

/**
 * Handle's the rendering of popular movie cards in the page.
 *
 * Extends of {@link mainView}
 */
class popularMoviesView extends mainView {
  _title = "Popular Movies";
}

export default new popularMoviesView();
